export const Tiles = {
    "m":["🀇", 	"🀈", 	"🀉", 	"🀊", 	"🀋", 	"🀌", 	"🀍", 	"🀎", 	"🀏"],
    "p":["🀙", 	"🀚", 	"🀛", 	"🀜", 	"🀝", 	"🀞", 	"🀟", 	"🀠", 	"🀡"],
    "s":["🀐", 	"🀑", 	"🀒", 	"🀓", 	"🀔", 	"🀕", 	"🀖", 	"🀗", 	"🀘"],
}
